import { call, put, takeEvery } from 'redux-saga/effects';
import { TOP_REQUEST, topSuccess, topFailure } from '../actions/actions';
import api from '../common/api';
import checkResponse from '../common/checkResponse';

function* handleRequest(action) {

  try {
    const response = yield call(api, action);
    const payload = yield response.json();

    if(!checkResponse(response, payload)) return;

    if( payload.sc === 0 && payload.errMsg == null ) {
      yield put(topSuccess(payload));
    } else {
      yield put(topFailure(payload));
    }
  } catch(error) {
    console.log("error ==> ",error);
  }
}

const topSaga = [takeEvery(TOP_REQUEST, handleRequest)];
export default topSaga;